<template>
  <div
    ref="content"
    class="cms-content"
  >
    <div
      v-if="getCmsData"
      :class="['parsed-cms-data', { 'container': sync }]"
      v-html="parsedCmsData"
    />
  </div>
</template>

<script>
import { isServer } from '@vue-storefront/core/helpers'
import { lazyloadImages } from 'vue-cms-data/lib/transformations'

export default {
  name: 'CmsBlock',
  props: {
    id: {
      type: Number,
      default: null,
      required: false
    },
    identifier: {
      type: String,
      default: null,
      required: false
    },
    sync: {
      type: Boolean,
      default: false,
      required: false
    },
    lazy: {
      type: Boolean,
      default: true,
      required: false
    },
    process: {
      type: Function,
      default: null,
      required: false
    }
  },
  serverPrefetch () {
    return this.fetchCmsBlock()
  },
  computed: {
    getCmsData () {
      if (this.id) {
        return this.$store.getters[`cmsBlock/getCmsBlockById`](this.id)
      } else if (this.identifier) {
        return this.$store.getters[`cmsBlock/getCmsBlockByIdentifier`](this.identifier)
      }
      return null
    },
    parsedCmsData () {
      if (this.getCmsData) {
        let content = this.getCmsData.content
        if (this.lazy) {
          // Replaces src with a transparent 1x1 pixel while image is loading
          content = content.replace(
            /<img([^>]*) src=/g,
            '<img$1 lazy="loading" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" data-src='
          )
        }
        if (this.process) {
          content = this.process(content)
        }
        return content
      }
      return null
    }
  },
  created () {
    if (!isServer) {
      this.fetchCmsBlock()
    }
  },
  mounted () {
    this.parseLazy()
  },
  methods: {
    async fetchCmsBlock () {
      let queryKey = ''
      let queryValue = ''
      if (this.id) {
        queryKey = 'id'
        queryValue = this.id
      } else if (this.identifier) {
        queryKey = 'identifier'
        queryValue = this.identifier
      }
      if (queryKey && queryValue) {
        await this.$store.dispatch('cmsBlock/single', {
          key: queryKey,
          value: queryValue
        })
        this.parseLazy()
      }
    },
    parseLazy () {
      this.$nextTick(() => {
        if (this.lazy && this.$refs.content) {
          lazyloadImages(this.$refs.content, {
            context: this
          })
        }
      })
    }
  }
}
</script>
